import React from 'react'
import styled from 'styled-components'
import { Box, Text } from 'grommet'

const TypeText = styled(Text)`
  background-color: ${props => props.theme.global.colors[props.typeColor]};
  width: 5rem;
  font-size: 1.4rem;
  text-align: center;
  border-radius: 2rem;
`

const IndexText = styled(Text)`
  width: 5rem;
`

const NameText = styled(Text)`
  flex: 1;
  text-align: center;
`

const Container = styled(Box)`
  flex: 1;
  &::-webkit-scrollbar {
    width: 5px !important;
  }
  &::-webkit-scrollbar-track {
    background: ${props =>
      props.theme.global.colors.darkBgScrollTrack} !important;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: ${props =>
      props.theme.global.colors.darkBgScrollThumb} !important;
  }
  padding-right: 1rem;
  padding-left: 1rem;
`

const ItemBox = styled(Box)`
  flex-shrink: 0;
`

const History = ({ history }) => {
  if (history.length === 0)
    return (
      <Box flex={true}>
        <Text textAlign="center" size="1.6rem">
          This section shows all the results selected during the current visit.
        </Text>
      </Box>
    )
  return (
    <Container
      gap=".5rem"
      overflow={{ horizontal: 'hidden', vertical: 'auto' }}
      //   height="40rem"
    >
      {history.map((item, index) => {
        let typeName = ''
        let typeColor = 'transparent'
        if (item.type === 'HIDE') {
          typeName = `HIDE`
          typeColor = 'secondary'
        } else if (item.type === 'ADD') {
          typeName = `+1`
          typeColor = 'primary'
        }
        return (
          <ItemBox
            direction="row"
            key={`allResultsHistory${index}`}
            justify="between"
            height="2.4rem"
          >
            <IndexText>{index + 1}.</IndexText>
            <NameText truncate>{item.name}</NameText>
            <TypeText type={item.type} typeColor={typeColor} color="white">
              {typeName}
            </TypeText>
          </ItemBox>
        )
      })}
    </Container>
  )
}

export default History
